import Vue from 'vue'
import VueRouter from 'vue-router'
import Preference from '@/views/pages/preference/index.vue'
import CbdtCollection from '@/views/pages/cbdtCollection/index.vue'
import cbdtCollectionInvalid from '@/views/pages/cbdtCollection/Invalid.vue'
import koreaTermsCondtions from '@/views/pages/koreaTermsCondtions/index.vue'
import Error from '@/views/pages/error/Error.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/consent',
    name: 'preferenceCosmos',
    component: Preference
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/cpccenter',
    name: 'embedCpccenter',
    component: () => import('@/views/pages/embed/cpccenter/Index.vue'),
    meta: { title: '个人偏好' }
  },
  {
    path: '/ipad',
    component: { render: h => h('router-view') },
    children: [
      {
        path: 'registration',
        name: 'embedIpadRegistration',
        component: () => import('@/views/pages/embed/ipad/Registration.vue')
      }
    ]
  },
  {
    path: '/edm',
    component: { render: h => h('router-view') },
    children: [
      {
        path: 'unsubscribe',
        name: 'embedEdmUnsubscribe',
        component: () => import('@/views/pages/embed/edm/Unsubscribe.vue')
      },
      {
        path: 'recollection',
        name: 'embedEdmRecollection',
        component: () => import('@/views/pages/embed/edm/Recollection.vue')
      }
    ]
  },
  {
    path: '/via',
    component: { render: h => h('router-view') },
    children: [
      {
        path: 'collection',
        name: 'cbdtCollection',
        component: CbdtCollection
      },
    ]
  },
  {
    path: '/cbdtCollectionInvalid',
    name: 'cbdtCollectionInvalid',
    component: cbdtCollectionInvalid
  },
  {
    path: '/koreaTermsCondtions',
    name: 'koreaTermsCondtions',
    component: koreaTermsCondtions,
    meta: { title: 'Korea Terms & Conditions' }
  },
  // 您可以在这里添加更多路由
  // {
  //   path: '/about',
  //   name: 'About',
  //   // 路由级代码分割
  //   // 这会为该路由生成一个单独的 chunk (about.[hash].js)
  //   // 当路由被访问时才会加载。
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由访问控制(路由拦截)
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta?.title || 'CHANEL';
  
  // 允许访问的路由name列表
  const allowList = [
    // 'preferenceCosmos',
    'embedIpadRegistration',
    'embedCpccenter',
    'embedEdmUnsubscribe',
    'embedEdmRecollection',
    "cbdtCollection",
    // "cbdtCollectionInvalid",
    'koreaTermsCondtions',
    'error'
  ];
  if (allowList.includes(to.name)) {
    next();
  }else {
    next('/error');
  }
})

export default router 